var { initIframePrint } = require('./shared/iframe-print');

/**
 * Online Journal - Interactive journaling tool with mood tracking and prompts
 * @namespace OnlineJournal
 */
(function() {
    'use strict';

    /**
     * Initialize the journal functionality
     */
    function init() {
        restoreScrollPosition();

        var form = document.getElementById('journalForm');
        if (form) {
            form.addEventListener('submit', saveScrollPosition);
        }

        setupMoodSelector();
        setupPromptButtons();
        setupClearButton();
        setupWordCounter();
        initializeDate();

        initIframePrint({
            formId: 'ojPrintForm',
            iframeId: 'ojPrintFrame',
            buttonId: 'ojPrintBtn',
            readyLabel: '<i class="bi bi-printer me-2" aria-hidden="true"></i>Print Entry',
            sourceFormId: 'journalForm',
            inputFieldId: 'ojInputJson',
        });
    }

    /**
     * Handle mood selector clicks
     */
    function setupMoodSelector() {
        document.querySelectorAll('.mood-btn').forEach(function(btn) {
            btn.addEventListener('click', function(e) {
                document.querySelectorAll('.mood-btn').forEach(function(b) {
                    b.classList.remove('selected');
                });
                
                this.classList.add('selected');
                
                const radio = this.querySelector('input[type="radio"]');
                if (radio) {
                    radio.checked = true;
                }
            });
        });
    }

    /**
     * Handle prompt button clicks - insert prompt into journal content
     */
    function setupPromptButtons() {
        document.querySelectorAll('.prompt-tag').forEach(function(btn) {
            btn.addEventListener('click', function() {
                const prompt = this.getAttribute('data-prompt');
                const textarea = document.querySelector('textarea[name="JournalContent"]');
                const currentContent = textarea.value;
                
                if (currentContent.trim() === '') {
                    textarea.value = '**' + prompt + '**\n\n';
                } else {
                    textarea.value = currentContent + '\n\n**' + prompt + '**\n\n';
                }
                
                textarea.focus();
                textarea.scrollTop = textarea.scrollHeight;
            });
        });
    }

    /**
     * Clear button - opens confirmation modal
     */
    function setupClearButton() {
        const clearButton = document.getElementById('onlineJournalClear');
        const overlay = document.getElementById('clearConfirmationOverlay');
        if (!clearButton || !overlay) {
            return;
        }

        const closeButtons = overlay.querySelectorAll('[data-clear-confirmation="close"]');

        clearButton.addEventListener('click', function () {
            openClearConfirmation(overlay);
        });

        closeButtons.forEach(function (button) {
            button.addEventListener('click', function () {
                closeClearConfirmation(overlay);
            });
        });
    }

    /**
     * Open the clear confirmation modal
     * @param {HTMLElement} overlay The modal overlay element
     */
    function openClearConfirmation(overlay) {
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        if (scrollbarWidth > 0) {
            document.body.style.paddingRight = scrollbarWidth + 'px';
        }
        overlay.classList.add('is-visible');
        overlay.setAttribute('aria-hidden', 'false');
        document.body.classList.add('clear-confirmation-open');
    }

    /**
     * Close the clear confirmation modal
     * @param {HTMLElement} overlay The modal overlay element
     */
    function closeClearConfirmation(overlay) {
        overlay.classList.remove('is-visible');
        overlay.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('clear-confirmation-open');
        document.body.style.paddingRight = '';
    }

    /**
     * Update word count as user types
     */
    function setupWordCounter() {
        const journalContent = document.querySelector('textarea[name="JournalContent"]');
        const wordCountElement = document.getElementById('word-count');
        
        journalContent.addEventListener('input', function() {
            const text = this.value.trim();
            const wordCount = text === '' ? 0 : text.split(/\s+/).length;
            wordCountElement.textContent = 'Words: ' + wordCount;
        });
    }

    /**
     * Initialize date to today (using local timezone, not UTC)
     */
    function initializeDate() {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        document.querySelector('input[name="EntryDate"]').value = `${year}-${month}-${day}`;
    }

    /**
     * Save current scroll position to sessionStorage before form submission
     * Skips saving if the confirmation modal is visible to preserve the original position
     */
    function saveScrollPosition() {
        const modalOverlay = document.querySelector('.clear-confirmation-overlay.is-visible');
        if (modalOverlay) {
            return;
        }

        try {
            sessionStorage.setItem('onlineJournalScrollPos', window.pageYOffset.toString());
        } catch (e) {
            // Ignore storage errors
        }
    }

    /**
     * Restore scroll position from sessionStorage after page load
     * Only removes saved position when modal is not visible (to support Confirm/Cancel flow)
     */
    function restoreScrollPosition() {
        try {
            const scrollPos = sessionStorage.getItem('onlineJournalScrollPos');
            if (scrollPos) {
                window.scrollTo(0, parseInt(scrollPos, 10));
                
                const modalOverlay = document.querySelector('.clear-confirmation-overlay.is-visible');
                if (!modalOverlay) {
                    sessionStorage.removeItem('onlineJournalScrollPos');
                }
            }
        } catch (e) {
            // Ignore storage errors
        }
    }

    /**
     * Escape HTML to prevent XSS
     * @param {string} text - Text to escape
     * @returns {string} Escaped HTML string
     */
    function escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();
